// extracted by mini-css-extract-plugin
export default {"headerControls":"HeaderControls_headerControls__Apihn"};